var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "section-wrapper w-100" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm._f("capitalize")(_vm.$tc("global.doorr.agent", 1))
                    ) +
                    "\n            "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _vm.loading
              ? _c("participants-loader")
              : _c("agent", {
                  attrs: {
                    "application-id": _vm.applicationId,
                    "client-username": _vm.clientUsername,
                    "agent-username": _vm.agentUsername,
                  },
                }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "row align-items-end" }, [
              _c(
                "h2",
                {
                  staticClass:
                    "section-separator-title col-6 text-left align-self-center",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("direct-to-lender.participants.submissionAgent")
                      ) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 text-right single-line-height" },
                [
                  _c("simple-button", {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.sync-agent-from-expert-modal",
                        modifiers: { "sync-agent-from-expert-modal": true },
                      },
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: {
                          title: _vm.$t(
                            "direct-to-lender.participants.syncAgentFromExpert"
                          ),
                        },
                        expression:
                          "{\n                title: $t('direct-to-lender.participants.syncAgentFromExpert')\n              }",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      "class-name": "btn-sm float-right",
                      text: _vm.$t("global.actions.importFromExpert"),
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.loading
                ? _c("participants-loader")
                : _c("submission-agent", {
                    attrs: {
                      "application-id": _vm.applicationId,
                      "client-username": _vm.clientUsername,
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c("sync-agent-from-expert-modal", {
            ref: "syncAgentFromExpertModal",
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.REFERRAL_SOURCE_ENABLED
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("div", { staticClass: "row align-items-end" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "section-separator-title col-6 text-left align-self-center text-capitalize",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("global.doorr.referrer", 1)) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm.loading
                  ? _c("participants-loader")
                  : _c("participant-referrer", {
                      attrs: {
                        "application-id": _vm.applicationId,
                        "client-username": _vm.clientUsername,
                      },
                    }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.allowCoBroker
        ? _c(
            "div",
            { staticClass: "card" },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("div", { staticClass: "row align-items-end" }, [
                  _c("div", { staticClass: "col-6 align-self-center" }, [
                    _c(
                      "h2",
                      { staticClass: "section-separator-title text-left" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("direct-to-lender.participants.coBroker")
                            ) +
                            "\n\n              "
                        ),
                        _c(
                          "span",
                          { staticStyle: { "font-size": "0.875rem" } },
                          [
                            _c("i", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: _vm.$t(
                                    "direct-to-lender.participants.coBrokerDescription"
                                  ),
                                  expression:
                                    "\n                    $t('direct-to-lender.participants.coBrokerDescription')\n                  ",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "fa fa-info-circle text-grey ml-1",
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 text-right single-line-height" },
                    [
                      _vm.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES &&
                      _vm.hasCoBrokeringOverrides
                        ? _c("simple-button", {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.co-broker-modal",
                                modifiers: { "co-broker-modal": true },
                              },
                            ],
                            attrs: {
                              type: "primary",
                              "class-name": "btn-sm float-right",
                              text: _vm.$t(
                                "direct-to-lender.participants.coBroker"
                              ),
                            },
                          })
                        : _c("simple-button", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.top",
                                value: _vm.coBrokeringTooltip,
                                expression: "coBrokeringTooltip",
                                modifiers: { top: true },
                              },
                            ],
                            attrs: {
                              disabled: "",
                              type: "primary",
                              "class-name": "btn-sm float-right",
                              text: _vm.$t(
                                "direct-to-lender.participants.coBroker"
                              ),
                            },
                          }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("participants-co-broker", {
                    attrs: {
                      "application-id": _vm.applicationId,
                      "client-username": _vm.clientUsername,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("co-broker-modal", {
                attrs: {
                  "application-id": _vm.applicationId,
                  "client-username": _vm.clientUsername,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }